<template>
  <div
    v-if="entriesLoaded && siteDataLoaded"
    class="w-screen h-screen font-sans"
  >
    <svg
      class="w-0 h-0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 688 1498.81"
    >
      <defs>
        <clipPath id="clipPath1" clipPathUnits="objectBoundingBox">
          <path
            d="M0.006,0.509 C0,0.467,0.003,0.426,0.004,0.384 Q0.007,0.297,0.008,0.209 C0.009,0.177,0.007,0.145,0.006,0.113 C0.006,0.099,0.004,0.086,0.004,0.073 C0.004,0.061,0.006,0.05,0.016,0.039 C0.034,0.02,0.065,0.007,0.11,0.002 C0.121,0.001,0.133,0.001,0.144,0.001 C0.275,0.001,0.405,0.002,0.536,0.002 C0.608,0.002,0.68,0.001,0.752,0 C0.791,0,0.83,0,0.868,0.001 A0.164,0.076,0,0,1,0.948,0.013 C0.983,0.023,0.997,0.038,0.999,0.056 C1,0.065,0.999,0.074,0.998,0.083 C0.993,0.166,0.995,0.249,0.996,0.332 C0.998,0.406,1,0.48,1,0.553 C1,0.608,0.999,0.662,0.999,0.716 C0.999,0.778,1,0.839,1,0.901 C1,0.92,1,0.938,0.991,0.956 C0.978,0.98,0.94,0.996,0.886,0.999 C0.858,1,0.829,1,0.8,1 C0.639,0.999,0.479,0.998,0.318,1 C0.253,1,0.188,1,0.124,0.999 C0.071,0.999,0.019,0.981,0.007,0.958 C0.004,0.953,0.004,0.947,0.004,0.942 C0.004,0.897,0.006,0.853,0.006,0.808 C0.006,0.775,0.002,0.742,0.002,0.709 C0.002,0.665,0.005,0.62,0.006,0.576 C0.006,0.553,0.006,0.531,0.006,0.509"
          />
        </clipPath>
        <clipPath id="clipPath2" clipPathUnits="objectBoundingBox">
          <path
            d="M0.488,0.992 C0.379,0.994,0.269,0.998,0.159,1 C0.138,1,0.117,1,0.096,0.993 C0.05,0.977,0.022,0.929,0.013,0.848 A0.469,0.807,0,0,1,0.005,0.714 C0.004,0.55,0.002,0.385,0.001,0.221 C0,0.114,0.054,0.014,0.116,0.006 C0.139,0.004,0.161,0.008,0.184,0.008 C0.262,0.009,0.34,0.01,0.418,0.008 C0.548,0.007,0.679,0.003,0.809,0.001 C0.839,0,0.869,0.002,0.897,0.018 A0.233,0.401,0,0,1,0.928,0.039 C0.964,0.07,0.985,0.118,0.988,0.188 C0.99,0.229,0.993,0.27,0.993,0.311 C0.992,0.397,0.996,0.482,0.998,0.567 C1,0.635,1,0.703,0.998,0.771 C0.991,0.873,0.957,0.942,0.902,0.979 C0.876,0.998,0.848,1,0.819,0.999 C0.719,0.99,0.618,0.99,0.518,0.992 C0.508,0.992,0.498,0.992,0.488,0.992 C0.488,0.993,0.488,0.991,0.488,0.992"
          />
        </clipPath>
        <clipPath id="clipPath3" clipPathUnits="objectBoundingBox">
          <path
            d="M0.995,0.998 C0.986,0.986,0.988,0.973,0.986,0.96 C0.986,0.949,0.986,0.938,0.986,0.927 C0.987,0.869,0.984,0.81,0.986,0.752 Q0.988,0.704,0.99,0.656 C0.988,0.614,0.991,0.571,0.986,0.528 C0.992,0.468,0.987,0.409,0.99,0.349 C0.991,0.329,0.993,0.309,0.993,0.289 C0.993,0.272,0.991,0.255,0.994,0.239 A0.044,0.026,0,0,0,0.996,0.228 C0.994,0.184,1,0.14,1,0.095 C0.999,0.087,1,0.079,1,0.071 C1,0.055,0.995,0.039,0.992,0.023 L0.985,0,0,0.001 L0.005,1"
          />
        </clipPath>
      </defs>
    </svg>
    <Legend
      @clicked="selectedCategory = $event"
      :siteData="siteData"
      :selectedCategory="selectedCategory"
    />
    <Map
      class="font-sans"
      :isLandscape="isLandscape()"
      :entries="entries"
      :categories="siteData.categories"
      :selectedCategory="selectedCategory"
      @reset="selectedCategory = null"
    />
    <div
      class="fixed text-center tracking-wide text-gray-700 text-sm transform -translate-x-1/2 bottom-4 left-1/2 z-[9999]"
    >
      <a class="uppercase" target="_blank" href="https://www.hubbub.org.uk/">
        <svg
          class="block w-64 h-auto mb-2"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="31 183 350 68"
        >
          <path
            fill="#000"
            d="M95.5 183h-1.4v31.9h1.4V183zM94.1 234c0 2.4.6 4.7 1.4 6.8v-21.7h-1.4V234zM128.6 183h-1.4v31.9h1.4V183zM127.1 240.8c.9-2.1 1.4-4.4 1.4-6.8v-14.9h-1.4v21.7zM109.7 183h-1.4v31.9h1.4V183zM108.3 250.7v.3h1.4v-31.9h-1.4v31.6zM103.6 249.2c.4.3 1 .4 1.4.7v-30.7h-1.4v30zM105 183h-1.4v31.9h1.4V183zM100.3 183h-1.4v31.9h1.4V183zM98.8 245.8c.4.4.9 1 1.4 1.4v-28.1h-1.4v26.7zM114.5 183H113v31.9h1.4V183h.1zM113 251h1.4v-31.9H113V251zM119.1 183h-1.4v31.9h1.4V183zM117.6 249.9c.4-.1 1-.4 1.4-.7v-30h-1.4v30.7zM122.4 247c.6-.4 1-.8 1.4-1.4v-26.5h-1.4V247zM123.8 183h-1.4v31.9h1.4V183zM32.4 183H31v31.9h1.4V183zM32.4 219.1H31v31.7h1.4v-31.7zM65.5 219.1H64v31.7h1.4l.1-31.7zM65.5 183H64v31.9h1.4l.1-31.9zM46.7 183h-1.4v31.9h1.4V183zM46.7 219.1h-1.4v31.7h1.4v-31.7zM41.9 219.1h-1.4v31.7h1.4v-31.7zM41.9 183h-1.4v31.9h1.4V183zM37.2 219.1h-1.4v31.7h1.4v-31.7zM37.2 183h-1.4v31.9h1.4V183zM51.3 219.1h-1.4v31.7h1.4v-31.7zM51.3 183h-1.4v31.9h1.4V183zM56 219.1h-1.4v31.7H56v-31.7zM56 183h-1.4v31.9H56V183zM60.7 183h-1.4v31.9h1.4V183zM60.7 219.1h-1.4v31.7h1.4v-31.7zM158.6 219.1h-1.4v31.7h1.4v-31.7zM158.6 183h-1.4v31.9h1.4V183zM190.2 193.2v13.6c.9-2.1 1.4-4.4 1.4-6.8s-.4-4.7-1.4-6.8zM190.2 240.8c.9-2.1 1.4-4.4 1.4-6.8s-.6-4.7-1.4-6.8v13.6zM171.4 250.7v.3h1.4v-31.9h-1.4v31.6zM172.8 183.1v-.1h-1.4v31.9h1.4v-31.8zM168.1 183h-1.4v31.9h1.4V183zM168.1 219.1h-1.4v31.7h1.4v-31.7zM163.3 219.1h-1.4v31.7h1.4v-31.7zM163.3 183h-1.4v31.9h1.4V183zM177.6 183.3v-.3h-1.4v31.8h1.4v-31.5zM176.1 251h1.4v-31.9h-1.4V251zM182.3 184.8c-.4-.3-1-.4-1.4-.7v30.6h1.4v-29.9zM180.9 249.9c.4-.1 1-.4 1.4-.7v-30h-1.4v30.7zM187 188.4c-.4-.4-.9-1-1.4-1.4v26c.6-.4 1-.9 1.4-1.4v-23.2zM185.6 247c.6-.4 1-.8 1.4-1.4v-23.2c-.4-.4-.9-1-1.4-1.4v26zM283.4 234c0 2.4.6 4.7 1.4 6.8v-21.7h-1.4V234zM284.9 183h-1.4v31.9h1.4V183zM317.9 183h-1.4v31.9h1.4V183zM316.5 240.8c.9-2.1 1.4-4.4 1.4-6.8v-14.9h-1.4v21.7zM299 183h-1.4v31.9h1.4V183zM297.5 250.7v.3h1.4v-31.9h-1.4v31.6zM294.4 183H293v31.9h1.4V183zM292.9 249.2c.4.3 1 .4 1.4.7v-30.7h-1.4v30zM289.6 183h-1.4v31.9h1.4V183zM288.2 245.8c.4.4.9 1 1.4 1.4v-28.1h-1.4v26.7zM302.3 251h1.4v-31.9h-1.4V251zM303.7 183h-1.4v31.9h1.4V183zM308.4 183H307v31.9h1.4V183zM307 249.9c.4-.1 1-.4 1.4-.7v-30H307v30.7zM313.2 183h-1.4v31.9h1.4V183zM311.7 247c.6-.4 1-.8 1.4-1.4v-26.5h-1.4V247zM348 183h-1.4v31.9h1.4V183zM348 219.1h-1.4v31.7h1.4v-31.7zM379.6 193.2v13.6c.9-2.1 1.4-4.4 1.4-6.8s-.6-4.7-1.4-6.8zM379.6 240.8c.9-2.1 1.4-4.4 1.4-6.8s-.6-4.7-1.4-6.8v13.6zM362.2 183.1v-.1h-1.4v31.9h1.4v-31.8zM360.7 250.7v.3h1.4v-31.9h-1.4v31.6zM357.4 183H356v31.9h1.4V183zM357.4 219.1H356v31.7h1.4v-31.7zM352.7 219.1h-1.4v31.7h1.4v-31.7zM352.7 183h-1.4v31.9h1.4V183zM366.8 183.3v-.3h-1.4v31.8h1.4v-31.5zM365.3 251h1.4v-31.9h-1.4V251zM371.5 184.8c-.4-.3-1-.4-1.4-.7v30.6h1.4v-29.9zM370.1 249.9c.4-.1 1-.4 1.4-.7v-30h-1.4v30.7zM376.3 188.4c-.4-.4-.9-1-1.4-1.4v26c.6-.4 1-.9 1.4-1.4v-23.2zM374.8 247c.6-.4 1-.8 1.4-1.4v-23.2c-.4-.4-.9-1-1.4-1.4v26zM221.8 183h-1.4v31.9h1.4V183zM221.8 219.1h-1.4v31.7h1.4v-31.7zM253.4 193.2v13.6c.9-2.1 1.4-4.4 1.4-6.8s-.5-4.7-1.4-6.8zM253.4 240.8c.9-2.1 1.4-4.4 1.4-6.8s-.6-4.7-1.4-6.8v13.6zM234.4 250.7v.3h1.4v-31.9h-1.4v31.6zM235.9 183.1v-.1h-1.4v31.9h1.4v-31.8zM231.1 219.1h-1.4v31.7h1.4v-31.7zM231.1 183h-1.4v31.9h1.4V183zM226.4 183H225v31.9h1.4V183zM226.4 219.1H225v31.7h1.4v-31.7zM239.2 251h1.4v-31.9h-1.4V251zM240.6 183.3v-.3h-1.4v31.8h1.4v-31.5zM245.4 184.8c-.4-.3-1-.4-1.4-.7v30.6h1.4v-29.9zM243.9 249.9c.4-.1 1-.4 1.4-.7v-30h-1.4v30.7zM250.1 188.4c-.4-.4-.9-1-1.4-1.4v26c.6-.4 1-.9 1.4-1.4v-23.2zM248.7 247c.6-.4 1-.8 1.4-1.4v-23.2c-.4-.4-.9-1-1.4-1.4v26z"
          />
        </svg>
        <p>www.hubbub.org.uk</p>
      </a>
    </div>
  </div>
</template>

<script>
import Map from "./Map.vue";
import Legend from "./Legend.vue";

export default {
  name: "Overview",
  props: [],
  components: {
    Legend,
    Map,
  },
  data() {
    return {
      entries: [],
      errored: false,
      entriesLoaded: false,
      siteDataLoaded: false,
      siteData: {},
      selectedCategory: null,
    };
  },
  watch: {},
  methods: {
    isLandscape() {
      return (
        document.documentElement.clientWidth >
        document.documentElement.clientHeight
      );
    },
  },
  mounted() {
    axios
      .get("/api/all.json")
      .then((response) => {
        this.entries = response.data;
      })
      .catch((error) => {
        console.log(error);
        this.errored = true;
      })
      .finally(() => (this.entriesLoaded = true));

    axios
      .get("/api/site.json")
      .then((response) => {
        this.siteData = response.data;
      })
      .catch((error) => {
        console.log(error);
        this.errored = true;
      })
      .finally(() => (this.siteDataLoaded = true));
  },
};
</script>

<style lang="scss"></style>
